module.exports = __webpack_public_path__ + "static/img/file_pdf.dfb8e58a.png";